import { useState } from 'react';
import { LinkButton } from '../../../components/linkButton.tsx';
import { Operator } from '../../../types/sharedTypeImpl.ts';

type SortField = 'fullName' | 'initials' | 'shiftTeam';

interface SortState {
    field: SortField;
    direction: 'asc' | 'desc';
}

interface Props {
    style: React.CSSProperties;
    operators: Operator[];
    onIsActiveChange: (operator: Operator, isActive: boolean) => void;
    onEditClick: (operator: Operator) => void;
}

export function OperatorsTable({ style, operators, onIsActiveChange, onEditClick }: Props) {
    const [sortState, setSortState] = useState<SortState>({ field: 'fullName', direction: 'asc' });

    const sortedOperators = [...operators].sort((a, b) => {
        let comparison = 0;

        if (sortState.field === 'fullName') {
            comparison = a.fullName.localeCompare(b.fullName);
        } else if (sortState.field === 'initials') {
            comparison = a.initials.localeCompare(b.initials);
        } else {
            comparison = (a.shiftTeam ?? '').localeCompare(b.shiftTeam ?? '');
        }

        return sortState.direction === 'asc' ? comparison : -comparison;
    });

    function toggleSort(field: SortField) {
        setSortState((prev) => {
            if (prev.field === field) {
                return {
                    field,
                    direction: prev.direction === 'asc' ? 'desc' : 'asc',
                };
            }

            return {
                field,
                direction: 'asc',
            };
        });
    }

    function getSortIndicator(field: SortField): string {
        if (sortState.field !== field) return '';
        return sortState.direction === 'asc' ? ' ▲' : ' ▼';
    }

    return (
        <table style={style}>
            <thead>
                <tr>
                    <th>Is active</th>
                    <th style={{ cursor: 'pointer' }} onClick={() => toggleSort('fullName')}>
                        Full name{getSortIndicator('fullName')}
                    </th>
                    <th style={{ cursor: 'pointer' }} onClick={() => toggleSort('initials')}>
                        Initials{getSortIndicator('initials')}
                    </th>
                    <th style={{ cursor: 'pointer' }} onClick={() => toggleSort('shiftTeam')}>
                        Shift{getSortIndicator('shiftTeam')}
                    </th>
                    <th />
                </tr>
            </thead>
            <tbody>
                {sortedOperators.map((operator) => (
                    <tr key={operator._id}>
                        <td>
                            <input type='checkbox' checked={operator.isActive} onChange={(e) => onIsActiveChange(operator, e.target.checked)} />
                        </td>
                        <td style={{ textAlign: 'left', paddingLeft: '30px' }}>{operator.fullName}</td>
                        <td>{operator.initials}</td>
                        <td>{operator.shiftTeam}</td>
                        <td>
                            <LinkButton onClick={() => onEditClick(operator)} content='Edit' />
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
}
